import { render, staticRenderFns } from "./GiveawayRequestSummary.vue?vue&type=template&id=c47aeb40&"
import script from "./GiveawayRequestSummary.vue?vue&type=script&lang=js&"
export * from "./GiveawayRequestSummary.vue?vue&type=script&lang=js&"
import style0 from "./GiveawayRequestSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VIcon,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c47aeb40')) {
      api.createRecord('c47aeb40', component.options)
    } else {
      api.reload('c47aeb40', component.options)
    }
    module.hot.accept("./GiveawayRequestSummary.vue?vue&type=template&id=c47aeb40&", function () {
      api.rerender('c47aeb40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scheduling/requests/GiveawayRequestSummary.vue"
export default component.exports